<template>
  <h4 class="c-button" @click="clickButton()">{{ text }}</h4>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    clickButton() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.c {
  &-button {
    text-align: center;
    background-color: white;
    color: #707070;
    border-radius: 30px;
    padding: 12px;
    width: 200px;
    margin: 0 auto;
    cursor: pointer;
  }

  &-button::before,
  &-button::after {
    position: absolute;
    z-index: -1;
    display: block;
    content: '';
  }

  &-button,
  &-button::before,
  &-button::after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  &-button:hover {
    background-color: #f76868;
    color: white;
  }
}
</style>
